import type { ReactNode } from 'react';

/** Shared presentation for routed settings pages and embedded settings sections. */
export function SettingsPageFrame({
  children,
  variant = 'section',
}: {
  children: ReactNode;
  variant?: 'general' | 'analytics' | 'section';
}) {
  return (
    <div className="flex size-full min-h-0 min-w-0 flex-col">
      <div
        className={`flex min-h-0 flex-1 items-start justify-center overflow-y-auto [scrollbar-gutter:stable_both-edges] ${
          variant === 'general'
            ? 'p-6'
            : variant === 'analytics'
              ? 'px-4 pt-10 pb-8 sm:px-8'
              : 'px-4 pt-6 pb-8 sm:px-8 sm:pt-10'
        }`}
      >
        <div className="flex w-[736px] max-w-full shrink-0 flex-col gap-4">{children}</div>
      </div>
    </div>
  );
}
